<template>
  <div id="app">
    <Menu />
      <template v-if="$route.name == 'gift-vouchers'">
        <div v-if="show == true">
            <div class="loader"></div>
            <h2 class="loading">Loading...</h2>
        </div>
      </template>
      <transition name="fade" appear>
        <router-view :key="$route.fullPath"/>
      </transition>
      <CookieBanner />
    <Footer />
  </div>
</template>

<script>
import * as CryptoJS from 'crypto-js';
import Menu from './components/Menu.vue'
import Footer from './components/Footer.vue'
import CookieBanner from "@/components/CookieBanner.vue";
export default {
  name: 'App',
  components: {
    Menu,
    Footer,
    CookieBanner
  },
  data: function() {
    const CryptoJSAesJson = {
      'stringify': (cipherParams) => {
        const j = {ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64)};

        if (cipherParams.iv)
          j.iv = cipherParams.iv.toString();

        if (cipherParams.salt)
          j.s = cipherParams.salt.toString();

        return JSON.stringify(j);
      },
      'parse': (jsonStr) => {
        const j = JSON.parse(jsonStr);
        const cipherParams = CryptoJS.lib.CipherParams.create({ciphertext: CryptoJS.enc.Base64.parse(j.ct)});

        if (j.iv)
          cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv);

        if (j.s)
          cipherParams.salt = CryptoJS.enc.Hex.parse(j.s);

        return cipherParams;
      },
    };
    return {
      collectData: [],
      collectDataAuth: [],
      memberships: [],
      cryptoAES: CryptoJSAesJson,
      cryptoKey: 'ocssport',
      password: 'LP-309974',
      intervalid1: '',
      show: true,
    };
  },
  created() {
      setTimeout(() => {
        this.show = false;
      }, 3000);
  },
  methods: {
      encryptString: function(input) {
        return CryptoJS.AES.encrypt(input, this.cryptoKey).toString();
      },
      hashString(input) {
        return CryptoJS.SHA256(input).toString(CryptoJS.enc.Hex);
      },
      base64Decode(input) {
        const decStr = atob(input);
        const bytes = new Uint8Array(decStr.length);

        for (let i = 0; i < bytes.length; i++)
          bytes[i] = decStr.charCodeAt(i);

        return String.fromCharCode(...new Uint16Array(bytes.buffer));
      },
      socketAuthStr() {
        let sktMsg = '';
        // sktMsg += 'EG' + ' ';
        // sktMsg += '2000029000' + ' ';
        sktMsg += 'GUESTUSER@OCS-SOFTWARE.COM' + ' ';
        sktMsg += "'" + this.encryptString(this.password) + "' ";
        // sktMsg += 'a ';
        return sktMsg;
      },
      userLogin() {
				let sktMsg = '';
        sktMsg += 'EG '
				sktMsg += this.socketAuthStr();
				sktMsg += 'a';
        this.$socket.emit('mauth', sktMsg);
      },
			getFacGroups() {
				let sktMsg = '';
        sktMsg += '2000029000 '
				sktMsg += this.socketAuthStr();
				sktMsg += '.';
        // console.log('gl', sktMsg)
				this.$socket.emit('gl', sktMsg);
			},
      dataCollect() {
        this.sockets.subscribe('respgl', (data) => {
          // this.$root.debugLog('respgl');
          // this.$root.debugLog(data);

          try {
            const jsonDoc = JSON.parse(data);

            this.getAuthData(jsonDoc);
            this.collectData = jsonDoc;
          }
          catch (e) {
            this.$root.debugLog(e);
          }
        });
      },
      dataCollectMAuth() {
        this.sockets.subscribe('respmauth', (data) => {
          this.$root.debugLog('respgl');
          this.$root.debugLog(data);

          try {
            const jsonDocAuth = JSON.parse(data);
            this.collectDataAuth = jsonDocAuth;
            console.log("this.collectDataAuth")
            console.log(this.collectDataAuth)
            // uckfield club below
            this.memberships = this.collectDataAuth.my_clubs[1];
            console.log("this.memberships")
            console.log(this.memberships)
            this.getFacGroups();
          }
          catch (e) {
            this.$root.debugLog(e);
          }
        });
      }
			// encryptPassword(input) {
			// 	return CryptoJS.AES.encrypt(input, appConfig.cryptPasswd).toString();
			// },
			// encryptString(input, passw) {
			// 	return Base64.encode(CryptoJS.AES.encrypt(JSON.stringify(input), passw, {format: this.cryptoAES}).toString());
			// },
  },
  mounted() {
    // this.getAuthData();
    this.timeoutzone();
    this.userLogin();
    this.dataCollect();
    this.dataCollectMAuth();
  }
}
</script>

<style>
.loading {
  color: #242533;
  font-weight: bold;
  font-style: italic;
  margin-bottom: 100px;
}
.loader {
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #000000;
  width: 120px;
  height: 120px;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
  margin: auto;
  margin-top: 20px;
  margin-bottom: 20px;
}

/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,100..900;1,100..900&display=swap');
.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}
@media (min-width: 1200px) {
    .container, .container-sm, .container-md, .container-lg, .container-xl {
        max-width: 1400px!important;
    }
}
.v-enter-from,
.v-leave-to {
  opacity: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #fff;
  overflow-x: hidden;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter-active {
  transition-delay: 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.cookie-banner {
  position: fixed;
  bottom: 20px;
  left: 20px;
  right: 20px;
  max-width: 900px;
  margin: 0 auto;
  background: #1f1f1f;
  color: #fff;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  z-index: 999999;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  animation: cookieSlideUp .35s ease;
}

.cookie-banner p {
  margin: 0;
  line-height: 1.6;
  font-size: 15px;
  flex: 1;
}

.cookie-banner .buttons {
  display: flex;
  gap: 12px;
  flex-shrink: 0;
}

.cookie-banner button {
  border: none;
  border-radius: 8px;
  padding: 12px 22px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all .2s ease;
}

.cookie-banner button:first-of-type {
  background: transparent;
  border: 1px solid #666;
  color: #fff;
}

.cookie-banner button:first-of-type:hover {
  background: #333;
}

.cookie-banner button:last-of-type {
  background: #00a651;
  color: #fff;
}

.cookie-banner button:last-of-type:hover {
  background: #008d45;
  transform: translateY(-1px);
}

@keyframes cookieSlideUp {
  from {
    opacity: 0;
    transform: translateY(40px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 768px) {
  .cookie-banner {
    left: 10px;
    right: 10px;
    bottom: 10px;
    padding: 18px;
    flex-direction: column;
    align-items: stretch;
  }

  .cookie-banner .buttons {
    width: 100%;
    flex-direction: column;
  }

  .cookie-banner button {
    width: 100%;
  }
}
</style>
